module.exports = __webpack_public_path__ + "static/media/Landingpage_Image.e45d4325.png";